<mat-dialog-content>
  <div style="display: flex; flex-direction: column; height: 100%">
    <mat-icon (click)="closeSupportDialog()" class="close-icon">close</mat-icon>
    <div class="input-container">
      <div class="container">
        <div class="header">Subject</div>
        <textarea [(ngModel)]="subject" class="input-field subject"></textarea>
      </div>
      <div class="container">
        <div class="header">Description</div>
        <textarea [(ngModel)]="description" class="input-field description"></textarea>
        <!-- <input [(ngModel)]="description" class="input-field description" /> -->
      </div>
      <div class="submit">
        <button (click)="submitQuery()" class="my-red-button">Submit</button>
      </div>
    </div>
  </div>
</mat-dialog-content>
